import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobilePlanning } from '@/features/planning/mobile/MobilePlanning';
import { DesktopPlanning } from '@/features/planning/desktop/DesktopPlanning';

export const Route = createFileRoute('/_app/planning/')({ component: PlanningPage });

/** Selettore: Pianificazione mobile dedicata vs Agenda desktop brand. */
function PlanningPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobilePlanning /> : <DesktopPlanning />;
}
